<template>
  <div class="mainBox sectionProfil">
    <div class="identity">
      <div @click="$parent.showAlbum(profile.mainPicture.id)" class="grandCadrePhoto">
        <Photo :profile="profile" :pic="profile.mainPicture" zoom />
        <ConnectedIcon :profile="profile" />
        <div class="boutonsRonds" v-if="!$parent.ownProfile">
          <div>
            <FavorisButton :profile="profile" />
            <div class="text">Ajouter</div>
          </div>
          <div>
            <FlashButton :profile="profile" :disabled="$store.state.profile.validated == false" />
            <div class="text">Flasher</div>
          </div>
          <div>
            <MessageButton :profile="profile" :disabled="$store.state.profile.validated == false" />
            <div class="text">Lui écrire</div>
          </div>
        </div>
        <div class="boutonsRonds" v-else>
          <span v-if="$parent.ownProfile" @click.stop.prevent="openUploader" class="petitBouton boutonRond messageRond">
            <img :src="'/assets/icons_' + $store.state.iconTheme + '/iconeplus.png'" />
          </span>
        </div>
        <a v-if="demander" class="bouton demander" @click.prevent="requestPicture">Demander une photo</a>
      </div>

      <div class="infosProfil">
        <Pseudo :profile="profile">, {{ profile.age }} ans </Pseudo>
        <div class="infosCompl">
          <div class="ville">
            {{ profile.city.name }} ({{ profile.city.zip }})<br />
            {{ profile.city.country.name }}
          </div>

          <div class="zodiac">
            <img :src="profile.zodiacMap.src" />
            <label>{{ profile.zodiacMap.label }}</label>
          </div>

          <div class="lastCo" v-if="!$parent.ownProfile && serenity && lastConnection">{{ lastConnection }}</div>
          <div class="lastCo" v-if="!$parent.ownProfile && !serenity">
            <router-link :to="{ name: 'Serenite' }" class="pinkLink" v-if="hasPass"
              >Date de dernière connexion (cliquer ici pour la connaître)
            </router-link>
          </div>
          <PassIcon v-if="$parent.ownProfile || admin" :profile="profile" />
        </div>
        <a v-if="nextAvailable" class="bouton suivant" @click="next">Profil suivant</a>
        <div class="albumPhoto">
          <div
            v-on:click.prevent="$parent.showAlbum(pic.id)"
            v-for="pic in additionnalPictures"
            :key="pic.id"
            class="albumCadrePhoto"
          >
            <Photo :profile="profile" :pic="pic" zoom thumb />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ConnectedIcon from "@/components/profile/ConnectedIcon";

import FlashButton from "@/components/buttons/FlashButton";
import FavorisButton from "@/components/buttons/FavorisButton";
import MessageButton from "@/components/buttons/MessageButton";
import Photo from "@/components/profile/Photo";
import Pseudo from "@/components/profile/Pseudo";
import PassIcon from "@/components/profile/PassIcon";
import { idyu_isAdmin, idyu_hasSerenity, idyu_hasPass } from "@/assets/js/idyu/util.js";
import { idyuJsonRpc } from "@/assets/js/idyu/connect.js";

export default {
  name: "Profil",
  components: {
    ConnectedIcon,
    Photo,
    FlashButton,
    FavorisButton,
    MessageButton,
    Pseudo,
    PassIcon
  },

  props: {
    profile: {
      type: Object,
      default: null
    }
  },

  data() {
    return {
      passLogo: "",
      lastConnection: null
    };
  },

  computed: {
    hasPass() {
      return idyu_hasPass(this.$store.state.user.pass.permission);
    },

    additionnalPictures: function() {
      return this.profile.pictures.filter(elt => elt.id !== this.profile.mainPicture.id);
    },

    admin: function() {
      return idyu_isAdmin(this.$store.state.profile.permission);
    },

    nextAvailable: function() {
      if (this.$parent.ownProfile) return false;
      let ind = this.$store.state.lastResultIndex;
      let list = this.$store.state.lastSearch;

      if (list != null) {
        if (ind != -1) {
          if (list.fullyLoaded && list.result.list.length - 1 === ind) return false;
        }
        return true;
      }
      return false;
    },

    demander: function() {
      if (this.$parent.ownProfile) return false;
      return this.profile.pictures.length == 0;
    },

    serenity: function() {
      return idyu_hasSerenity(this.$store.state.user.pass.permission);
    }
  },

  mounted: function() {},

  methods: {
    init: async function() {
      if (this.serenity) {
        this.lastConnection = await idyuJsonRpc("getLastConnection", this.profile.id);
      }
    },

    openUploader: function() {
      this.$parent.$refs.up.open();
    },

    next: async function() {
      let ind = this.$store.state.lastResultIndex;
      let list = this.$store.state.lastSearch;

      ind++;
      if (list.result.list.length == ind) {
        await list.load();
      }
      this.$store.commit("setLastResultIndex", ind);
      this.$router.push({ name: "Profil", query: { p: list.result.list[ind].profile.pseudo } });
    },

    requestPicture: async function(e) {
      e.stopPropagation();
      await idyuJsonRpc("requestPicture", this.profile.pseudo);
      await alert("Une demande de photo a été envoyée à " + this.profile.pseudo);
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/css/vars.scss";

.boutonsRonds {
  position: absolute;
  bottom: -18px;
  right: 10px;
  display: grid;
  grid-auto-flow: column;
  grid-gap: 10px;
  z-index: 300;
  .text {
    display: none;
  }
}

.demander {
  position: absolute;
  bottom: 30px;
  left: 10px;
  z-index: 200;
  padding: 10px;
  right: 10px;
}

.suivant {
  margin-left: 3px;
}

.identity {
  display: grid;
  grid-template-columns: min-content;
  grid-gap: 25px;

  .infosProfil {
    display: grid;
    grid-template-rows: min-content min-content 1fr;
    grid-gap: 10px;
    padding-right: 10px;

    h1 {
      margin-top: 0px;
      margin-bottom: 0px;
      font-size: 18px;
      color: $theme_color;
      position: relative;
      font-weight: bold;
    }

    .infosCompl {
      display: grid;
      grid-gap: 10px;
      .zodiac {
        position: relative;
        padding-left: 30px;
        img {
          position: absolute;
          width: 25px;
          left: 0;
          top: -5px;
        }
      }
    }
  }

  .lignePhotos {
    display: grid;
    grid-template-columns: min-content auto;
    grid-gap: 10px;
  }
}

.albumPhoto {
  display: grid;

  grid-template-columns: min-content min-content;
  align-content: center;
  justify-content: center;
  grid-gap: 10px;
  .albumCadrePhoto {
    max-width: none;
  }
  overflow-x: hidden;
  overflow-y: visible;
}

.ligneBoutons {
  display: none;
}

@media screen and (max-width: 845px) {
  .albumPhoto {
    display: grid;
    grid-template-columns: none;
    grid-auto-flow: column;
    grid-auto-columns: min-content;
    justify-content: left;
    align-content: end;
    grid-gap: 10px;
    .albumCadrePhoto {
      max-width: none;
    }
    overflow-x: auto;
    overflow-y: hidden;
  }
}

.lastCo {
  font-style: italic;
}

@media screen and (min-width: 550px) {
  .mainBox {
    position: fixed;
    overflow-x: visible;
    overflow-y: scroll;
    position: absolute;
    top: 0;
    left: 10px;
    bottom: 10px;
    padding-right: 2px;
  }
}
@media screen and (max-width: 550px) {
  .albumPhoto {
    display: none;
  }

  .identity {
    grid-template-columns: 1fr;
    grid-gap: 10px;
    justify-content: left;
  }

  .suivant {
    margin-bottom: 10px;
  }

  .ownProfile .identity {
    justify-content: center;
  }

  .boutonsRonds {
    grid-auto-flow: row;
    grid-auto-rows: max-content;
    grid-gap: 15px;
    bottom: 15px;
    left: 218px;

    .text {
      display: block;
    }
    div {
      display: grid;
      grid-auto-flow: column;
      grid-auto-columns: max-content;
      align-items: center;
      align-content: center;
      grid-gap: 5px;
    }
  }
}
</style>
